import React from 'react';

export const ProductContext = React.createContext({
  auth: null
});
